<template>
  <div>
    <v-navigation-drawer
      :width="filter_view != 'filter' ? 900 : 600"
      fixed
      absolute
      temporary
      right
      v-model="options_c"
      dark
      hide-overlay
      class="px-2 navbar"
      style="position: fixed; top: 0px"
    >
      <!-- HEADER -->
      <v-layout row pt-0 mt-2 pl-2 white--text>
        <!-- this.$store.state.filterResults - {{$store.state.filterResults.length}}<br>
        use_current_selection - {{use_current_selection}}<br>
        this.unfiltered_artworks_for_list = {{unfiltered_artworks_for_list.length}}<br> -->

        <v-flex
          :class="[
            {
              xs3: filter_view == 'data',
              xs6: filter_view == 'filter',
            },
            'pl-2 pt-3 pb-0 ml-1',
          ]"
        >
          <a
            :class="[
              {
                'grey--text text--darken-2': filter_view != 'filter',
                'white--text': filter_view == 'filter',
              },
              'font-weight-regular headline font-weight-thin',
            ]"
            @click="filter_view = 'filter'"
            >Filter Artworks</a
          >
        </v-flex>
        <v-flex
          :class="[
            {
              xs3: filter_view == 'data',
              xs6: filter_view == 'filter',
            },
            'pl-3 pt-3 pb-0',
          ]"
        >
          <a
            :class="[
              {
                'grey--text text--darken-2': filter_view != 'data',
                'white--text': filter_view == 'data',
              },
              'font-weight-regular headline font-weight-thin',
            ]"
            @click="filter_view = 'data'"
            >Export</a
          >
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon color="" @click="closeOptions()" class="mr-2 mt-3">
          <v-icon>close</v-icon>
        </v-btn>

        <!-- <v-flex v-if="filter_view=='data'"></v-flex> -->
      </v-layout>

      <!-- <v-divider class="mx-3 pb-0 mb-3 white"></v-divider> -->

      <!-- FILTER SELECTOR -->
      <v-layout row wrap pt-0 px-3 ml-2 mt-2 v-show="filter_view == 'filter'">
        <v-flex xs12 class="text-xs-left mr-0 white--text">
          <p-check color="white" v-model="use_current_selection">
            <label color="white" slot="default"
              >Use artworks in current selection ({{
                this.currentSelection.length
              }})</label
            >
          </p-check>
          <p-check color="white" v-model="add_current_selection">
            <label color="white" slot="default"
              >Add artworks in current selection to artworks filtered below ({{
                this.currentSelection.length
              }})</label
            >
          </p-check>
          <p-check color="white" v-model="use_current_list_selection">
            <label color="white" slot="default"
              >Use checked artworks in filtered selection bellow ({{
                this.currentListSelection.length
              }})</label
            >
          </p-check>

          <!-- <v-checkbox
            xs6
            :disabled="(!this.currentSelection.length > 0 && use_current_list_selection)"
            :label="
              `Use artworks in current selection (${this.currentSelection.length})`
            "
            color="white"
            v-model="use_current_selection"
            hide-details
          ></v-checkbox>
          <v-checkbox
            xs6
            :disabled="!this.currentSelection.length > 0"
            :label="
              `Add artworks in current selection to artworks filtered below (${this.currentSelection.length})`
            "
            color="white"
            v-model="add_current_selection"
            hide-details
          ></v-checkbox>
          <v-checkbox
            xs6
            :disabled="!this.currentListSelection.length > 0"
            :label="
              `Use checked artworks in filtered selection bellow (${this.currentListSelection.length})`
            "
            color="white"
            v-model="use_current_list_selection"
            hide-details
          ></v-checkbox> -->
        </v-flex>

        <v-divider
          class="mx-1 pb-0 my-3 white"
          v-if="filter_view == 'filter'"
        ></v-divider>

        <!-- FILTER SELECT -->
        <v-flex
          class="xs12 pt-3 pb-2 px-1 font-weight-regular display-1 white--text"
        >
          <v-autocomplete
            :items="all_properties"
            v-model="filteredProperty"
            label="Select field to filter by:"
            item-text="name"
            single-line
            menu-props="bottom"
          ></v-autocomplete>
        </v-flex>

        <v-layout row wrap v-show="filteredProperty == 'location_history'">
          <v-flex xs12>
            <v-autocomplete
              :items="locations"
              v-model="query"
              item-text="name"
              item-value="id"
              label="Select Location"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="query_from"
              label="Date from"
              class="pr-2"
              placeholder="YYYY-MM-DD"
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="query_to"
              label="Date to"
              placeholder="YYYY-MM-DD"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-flex
          class="xs12 pt-0 pb-2 font-weight-regular display-1 white--text"
        >
          <v-text-field
            xs12
            v-show="
              text_properties.some((tp) => {
                return tp.value == filteredProperty
              })
            "
            v-model="query"
            label="Enter value"
          ></v-text-field>

          <div
            v-show="filteredProperty == 'acquisition_method'"
            v-for="c in this.constants.ACQUISITION_METHODS"
            v-bind:key="'as' + c.id"
          >
            <v-flex xs12 sm12 md12>
              <v-checkbox
                color="white"
                hide-details
                v-bind:label="c.name"
                v-bind:value="c.id"
                v-model="query_array"
              ></v-checkbox>
            </v-flex>
          </div>

          <div
            v-show="filteredProperty == 'ownership'"
            v-for="c in this.$store.getters.my_ownerships"
            v-bind:key="c.id"
          >
            <v-flex xs12 sm12 md12>
              <v-checkbox
                color="white"
                hide-details
                v-bind:label="c.name"
                v-bind:value="c.id"
                v-model="query_array"
              ></v-checkbox>
            </v-flex>
          </div>

          <div
            v-show="filteredProperty == 'acquired'"
            v-for="c in this.constants.OWNERSHIP_STATUSES"
            v-bind:key="c.name"
          >
            <v-flex xs12 sm12 md12>
              <v-checkbox
                color="white"
                hide-details
                v-bind:label="c.name"
                v-bind:value="c.id"
                v-model="query_array"
              ></v-checkbox>
            </v-flex>
          </div>

          <div
            v-show="filteredProperty == 'visa_status'"
            v-for="c in this.constants.VISA_STATUSES"
            v-bind:key="c.name"
          >
            <v-flex xs12 sm12 md12>
              <v-checkbox
                color="white"
                hide-details
                v-bind:label="c.name"
                v-bind:value="c.id"
                v-model="query_array"
              ></v-checkbox>
            </v-flex>
          </div>

          <!-- <v-container fluid v-show="filteredProperty == 'classification'">
            <v-layout row wrap>
              <v-flex
                xs6
                md3
                v-for="c in this.constants.CLASSIFICATIONS_TEMP"
                v-bind:key="c.id"
              >
                <v-checkbox
                  color="white"
                  hide-details
                  v-bind:label="c"
                  v-bind:value="c"
                  v-model="query_array"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container
            fluid
            v-show="filteredProperty == 'classification_new_id'"
          >
            <v-layout row wrap>
              <v-flex
                xs12
                lg6
                v-for="c in this.constants.CLASSIFICATIONS"
                v-bind:key="c.id"
              >
                <v-checkbox
                  color="white"
                  hide-details
                  v-bind:label="c.title"
                  v-bind:value="c.id"
                  v-model="query_array"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container> -->

          <v-container fluid v-show="filteredProperty == 'type_of_work_id'">
            <v-layout row wrap>
              <v-flex
                xs12
                lg6
                v-for="c in this.constants.TYPES_OF_WORK"
                v-bind:key="c.id"
              >
                <v-checkbox
                  color="white"
                  hide-details
                  v-bind:label="c.name"
                  v-bind:value="c.value"
                  v-model="query_array"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container fluid v-show="filteredProperty == 'tags'">
            <v-layout row wrap>
              <v-flex xs12>
                <!-- <v-autocomplete
                  v-model="selected_tags_assign"
                  :items="select_tags_assign"
                  label="Select tags "
                  item-text="name"
                  item-value="id"
                  multiple
                  chips
                  hint="Select tags to assign to selected artworks"
                  persistent-hint
                ></v-autocomplete>-->

                <v-autocomplete
                  hide-details
                  label="Tags"
                  multiple
                  chips
                  :items="select_tags_assign"
                  v-model="query_array"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>

          <v-layout
            row
            wrap
            v-show="
              filteredProperty == 'acquisition_date' ||
              filteredProperty == 'import_date'
            "
          >
            <v-flex xs6>
              <v-menu
                ref="menu_acq_from"
                :close-on-content-click="false"
                v-model="menu_acq_from"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  v-model="query_from"
                  label="From Date"
                  prepend-icon="event"
                  slot="activator"
                  readonly
                ></v-text-field>
                <v-date-picker
                  ref="picker"
                  v-model="query_from"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1956-01-01"
                  color="black"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6>
              <v-menu
                ref="menu_acq_to"
                :close-on-content-click="false"
                v-model="menu_acq_to"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  v-model="query_to"
                  label="To Date"
                  prepend-icon="event"
                  slot="activator"
                  readonly
                ></v-text-field>
                <v-date-picker
                  ref="picker"
                  v-model="query_to"
                  :max="new Date().toISOString().substr(0, 10)"
                  color="black"
                  min="1956-01-01"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>

          <v-layout
            row
            wrap
            v-show="
              filteredProperty == 'production_date_new' ||
              filteredProperty == 'deaccession_date'
            "
          >
            <v-flex xs6>
              <v-text-field
                v-model="query_from"
                label="Year from"
                class="pr-2"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="query_to" label="Year to"></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-show="filteredProperty == 'artwork_location_id'">
            <v-flex xs12>
              <v-autocomplete
                :items="locations"
                v-model="query_array"
                item-text="name"
                item-value="id"
                label="Select Locations"
                multiple
                chips
              ></v-autocomplete>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-show="filteredProperty == 'accession_number'">
            <v-flex xs6 md3 pr-3>
              <v-text-field
                v-model="anquery1"
                label="Enter value 1"
                color="white"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md3>
              <v-text-field
                v-model="anquery2"
                label="Enter value 2"
                color="white"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md3 pr-3>
              <v-text-field
                v-model="anquery3"
                label="Enter value 3"
                color="white"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md3>
              <v-text-field
                v-model="anquery4"
                label="Enter value 4"
                color="white"
              ></v-text-field>
            </v-flex>
            <!-- <v-flex xs12>
              <v-autocomplete
                :items="ans"
                v-model="query_array"
                label="Select Acquisition Numbers"
                multiple chips 
              ></v-autocomplete>
            </v-flex>-->
          </v-layout>

          <v-layout row wrap v-show="filteredProperty == 'exhibitions'">
            <v-flex xs12>
              <v-autocomplete
                :items="this.exhibitions"
                v-model="query_array"
                item-text="select_text"
                item-value="id"
                label="Select Exhibitions"
                chips
                multiple
              ></v-autocomplete>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-show="filteredProperty == 'artwork_series'">
            <v-flex xs12>
              <v-autocomplete
                :items="artworkSeries"
                v-model="query_array"
                item-text="title_en"
                item-value="id"
                label="Select Artwork Series"
                chips
                multiple
              ></v-autocomplete>
            </v-flex>
          </v-layout>

          <v-switch
            v-show="
              bool_properties.some((tp) => {
                return tp.value == filteredProperty
              })
            "
            :label="filteredProperty"
            class="pt-3 ml-3"
            v-model="query"
            color="black"
          ></v-switch>
        </v-flex>
        <!-- <input placeholder="filter value" v-model="query">     -->
        <v-flex xs12 text-xs-center mb-2 v-if="filteredProperty != 0">
          <v-btn
            class="mt-2"
            outline
            elevation-2
            mb-0
            @click.prevent="addFilter"
            >ACTIVATE FILTER</v-btn
          >
        </v-flex>
        <!-- <v-btn @click.prevent="loadCurrentSelection">LOAD CURRENT SELECTION</v-btn> -->
        <!-- <v-flex>
          <v-divider class="mx-0 red" ></v-divider>
        </v-flex>-->
      </v-layout>
      <!-- <hr> -->

      <!-- SELECTED FILTERS -->
      <v-list
        class="white--text mx-3 pt-2 mt-0"
        v-show="filter_view == 'filter' && this.activeFilters.length > 0"
        style="background-color: #444"
      >
        <v-flex ml-3>
          <h3 class="font-weight-regular display-0 white--text">
            Active Filters
          </h3>
        </v-flex>
        <!-- <tr>
          <th align=left colspan=3>Filters in use:</th>
        </tr>-->
        <v-list-tile
          v-for="(filter, index) in activeFilters"
          :key="index"
          style="
            padding-top: 20px;
            height: auto !important;
            border-spacing: 10px;
            margin-bottom: 15px;
          "
        >
          <v-layout
            row
            wrap
            align-center
            style="border: 1px solid #ddd; padding: 10px"
          >
            <v-flex style="width: 150px"
              >{{ filter.name.toUpperCase() }}:</v-flex
            >
            <v-flex align-start justify-start fill-height>
              <span
                v-if="
                  bool_properties.some((tp) => {
                    return tp.value == filter.name
                  })
                "
                >{{ filter.value ? 'YES' : 'NO' }}</span
              >
              <span
                v-if="
                  text_properties.some((tp) => {
                    return tp.value == filter.name
                  })
                "
                >{{ filter.value }}</span
              >
              <span
                v-if="
                  [
                    'production_date_new',
                    'acquisition_date',
                    'import_date',
                    'deaccession_date',
                  ].includes(filter.name)
                "
                >{{ filter.value_from }} - {{ filter.value_to }}</span
              >
              <span v-if="['classification'].includes(filter.name)">{{
                filter.value_array
              }}</span>
              <span v-if="['classification_new_id'].includes(filter.name)">{{
                filter.value_array
              }}</span>
              <span v-if="['type_of_work_id'].includes(filter.name)">{{
                filter.value_array
              }}</span>
              <span v-if="['artwork_location_id'].includes(filter.name)">
                <v-chip
                  small
                  v-for="t in keys2sentence(filter.value_array, filter.name)"
                  :key="t"
                  >{{ t }}</v-chip
                >
              </span>
              <span v-if="filter.name == 'visa_status'">{{
                keys2sentence(filter.value_array, filter.name)
              }}</span>
              <span v-if="filter.name == 'acquisition_method'">{{
                keys2sentence(filter.value_array, filter.name)
              }}</span>
              <!-- <span v-if="filter.name == 'accession_number'">{{keys2sentence(filter.value_array,filter.name)}} </span> -->
              <span v-if="filter.name == 'accession_number'"
                >{{ anquery1 }} {{ anquery2 }} {{ anquery3 }}
                {{ anquery4 }}</span
              >
              <span v-if="filter.name == 'exhibitions'">{{
                filter.value_array.length
              }}</span>
              <span v-if="filter.name == 'tags'">{{
                keys2sentence(filter.value_array, filter.name)
              }}</span>
              <span v-if="filter.name == 'ownership'">
                <i v-for="f in filter.value_array" :key="f">
                  {{
                    $store.getters.my_ownerships.find((o) => {
                      return o.id === f
                    }).name
                  }}
                  <br />
                </i>
                <!-- {{filter.value_array.length}}  -->
              </span>
              <span v-if="filter.name == 'acquired'">
                <i v-for="f in filter.value_array" :key="f">
                  {{
                    constants.OWNERSHIP_STATUSES.find((o) => {
                      return o.id === f
                    }).name
                  }}
                  <br />
                </i>
                <!-- {{filter.value_array.length}}  -->
              </span>
              <!-- <td>{{ filter.inverse ? 'NOT' : ''}}</td> -->
              <span class="right mx-2">
                <!-- <a href="#" @click.prevent=inverse(index)>{{filter.inverse ? '' : 'NOT'}}</a> -->
                <!-- <input type="checkbox" name="inverse" :value="filter.inverse" @click.prevent="inverse(index)">{{filter.inverse ? '' : 'NOT'}} -->
                <v-checkbox
                  v-show="
                    [
                      'production_date_new',
                      'acquisition_date',
                      'import_date',
                    ].includes(filter.name)
                  "
                  v-model="filter.inverse"
                  @click.prevent="inverse(index)"
                  hide-details
                  class="right"
                  v-bind:color="filter.inverse ? 'red' : 'green'"
                ></v-checkbox>
              </span>
            </v-flex>
            <v-flex>
              <span
                v-show="
                  [
                    'production_date_new',
                    'acquisition_date',
                    'import_date',
                  ].includes(filter.name)
                "
                class="right"
                >NOT</span
              >
            </v-flex>
            <v-flex>
              <span class="rigth">
                <v-btn
                  small
                  class="right"
                  icon
                  color="error"
                  @click.prevent="removeFilter(index)"
                >
                  <v-icon small>remove</v-icon>
                </v-btn>
              </span>
            </v-flex>
          </v-layout>
        </v-list-tile>
      </v-list>
      <v-flex xs12 my-2 mr-2 mt-5 v-if="filter_view == 'filter'">
        <v-btn
          @click.prevent="addToSelection(filteredArtworks)"
          class="right"
          outline
          >Add Filtered to Current Selection ({{
            filteredArtworks.length
          }})</v-btn
        >
      </v-flex>
      <!-- <v-flex xs12 my-2  v-if="filter_view=='filter'">
        <v-btn @click.prevent="resetFields()" class="right">CLEAR FILTERS AND FIELDS</v-btn>
      </v-flex>-->

      <!-- <v-container grid-list-xs text-xs-left red> -->
      <!-- <v-divider class="mx-3 pb-0 mb-4 white" v-if="filter_view=='data'"></v-divider> -->

      <!-- OUTPUT SETTINGS -->
      <v-layout
        row
        wrap
        mt-0
        mx-3
        pt-2
        class="font-weight-regular body-2 white--text"
        v-if="filter_view == 'data'"
      >
        <v-flex xs12 md6 pr-0 pl-2>
          <!-- @change="pdf(false)" -->
          <v-text-field
            label="Title"
            v-model="title"
            box
            dark
            clearable
            color="grey"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 md6 px-2>
          <v-text-field
            label="Subtitle"
            v-model="subtitle"
            clearable
            box
            color="grey"
            class="pl-2"
          ></v-text-field>
        </v-flex>

        <v-flex xs12>
          <!-- <v-divider class="mx-0 pb-0 mb-3 white"></v-divider> -->
        </v-flex>

        <!-- SETTINGS -->
        <v-flex xs6 px-2>
          <v-layout row wrap mt-0 pt-0>
            <v-flex xs6>
              <div
                class="
                  body-2
                  grey--text
                  text--darken-2 text-uppercase
                  font-weight-thin
                  mb-1
                "
              >
                Show
              </div>
              <p-check color="white" v-model="image">
                <label color="white" slot="default">Image</label>
              </p-check>
              <p-check color="white" v-model="page_no">
                <label color="white" slot="default">Page No.</label>
              </p-check>
              <p-check color="white" v-model="showNoOfArtworks">
                <label color="white" slot="default">No. of Artworks</label>
              </p-check>
              <p-check color="white" v-model="created_by">
                <label color="white" slot="default">Created by</label>
              </p-check>
              <p-check color="white" v-model="created_at">
                <label color="white" slot="default">Created at</label>
              </p-check>

              <!-- <v-checkbox
               class="mt-2"
                height="7"
                color="white"
                label="Image"
                v-model="image"
                hide-details
              ></v-checkbox>
              <v-checkbox
                height="7"
                color="white"
                label="Page No."
                v-model="page_no"
                hide-details
              ></v-checkbox>
              <v-checkbox
                height="7"
                color="white"
                label="No. of Artworks"
                v-model="showNoOfArtworks"
                hide-details
              ></v-checkbox>
              <v-checkbox
                height="7"
                color="white"
                label="Created by"
                v-model="created_by"
                hide-details
              ></v-checkbox>
              <v-checkbox
                height="7"
                color="white"
                label="Created at"
                v-model="created_at"
                hide-details
              ></v-checkbox> -->
            </v-flex>

            <v-flex xs6>
              <div
                class="
                  body-2
                  grey--text
                  text--darken-2 text-uppercase
                  font-weight-thin
                  mb-1
                "
              >
                Sizing
              </div>
              <!-- <v-radio-group
                class="mt-0"
                v-model="view"
                :mandatory="false"
                @change="pdf(false)"
              > -->
              <p-radio value="table" color="white" v-model="view"
                >Table View</p-radio
              >
              <p-radio value="compact" color="white" v-model="view"
                >Compact View</p-radio
              >
              <p-radio value="full" color="white" v-model="view"
                >Full View</p-radio
              >

              <!-- <v-radio
                  height="1"
                  color="white"
                  label="Table View"
                  value="table"
                ></v-radio>
                <v-radio
                  height="1"
                  color="white"
                  label="Compact View"
                  value="compact"
                ></v-radio>
                <v-radio height="1" color="white" label="Full View" value="full"></v-radio> -->
              <!-- </v-radio-group> -->
            </v-flex>
          </v-layout>

          <!-- <v-divider class="mt-5 pb-0 mb-3 white"></v-divider> -->

          <v-layout row wrap mt-4>
            <v-flex xs6 pr-2>
              <div
                class="
                  body-2
                  grey--text
                  text--darken-2 text-uppercase
                  font-weight-thin
                  mb-1
                "
              >
                Image Size
              </div>
              <!-- <p-radio value="50" color="white" v-model="imageSize2"
                >Table View</p-radio
              >
              <p-radio value="100" color="white" v-model="imageSize2"
                >Compact View</p-radio
              >
              <p-radio value="170" color="white" v-model="imageSize2"
                >Full View</p-radio
              > -->
              <!-- <v-radio-group
                class="mt-0"
                v-model="imageSize2"
                :mandatory="false"
                @change="pdf(false)"
              > -->
              <p-radio
                v-model="imageSize2"
                @change="pdf(false)"
                color="white"
                label=""
                value="50"
                >Small</p-radio
              ><br />
              <p-radio
                v-model="imageSize2"
                @change="pdf(false)"
                color="white"
                label=""
                value="100"
                >Normal</p-radio
              ><br />
              <p-radio
                v-model="imageSize2"
                @change="pdf(false)"
                color="white"
                label=""
                value="170"
                >Big</p-radio
              >
              <!-- </v-radio-group> -->
            </v-flex>

            <!-- <v-flex xs6>
              <div
                class="
                  body-2
                  grey--text
                  text--darken-2 text-uppercase
                  font-weight-thin
                  mb-1
                "
              >
                Image Quality
              </div>
              <p-radio value="normal" color="white" v-model="imageQuality"
                >Compact View</p-radio
              >
              <p-radio value="high" color="white" v-model="imageQuality"
                >Full View</p-radio
              >
            </v-flex> -->
            <!-- <v-radio-group v-model="imageQuality" :mandatory="false" class="mt-0">
                <v-radio color="white" label="Normal" value="normal"></v-radio>
                <v-radio color="white" label="High" value="high"></v-radio>
              </v-radio-group> -->
          </v-layout>

          <!-- <v-divider class="mt-3 pb-0 mb-3 white"></v-divider> -->

          <v-layout row wrap mt-3>
            <v-flex xs6>
              <div
                class="
                  body-2
                  grey--text
                  text--darken-2 text-uppercase
                  font-weight-thin
                  mb-1
                "
              >
                Sorting
              </div>
              <p-radio value="title" color="white" v-model="sort">Title</p-radio
              ><br />
              <p-radio value="sort_name" color="white" v-model="sort"
                >Artist</p-radio
              ><br />
              <p-radio value="collection" color="white" v-model="sort"
                >Collection</p-radio
              >
              <p-radio value="accession_number" color="white" v-model="sort"
                >Accession No.</p-radio
              >
              <p-radio value="acquisition_date" color="white" v-model="sort"
                >Acquisition Date</p-radio
              >
              <p-radio value="production_date_new" color="white" v-model="sort"
                >Production Date</p-radio
              >
              <p-radio value="location_name" color="white" v-model="sort"
                >Artwork Location</p-radio
              >
              <!-- <v-radio-group v-model="sort" :mandatory="false" class="mt-0">
                <v-radio color="white" label="Title" value="title"></v-radio>
                <v-radio
                  color="white"
                  label="Artist"
                  value="sort_name"
                ></v-radio>
                <v-radio
                  color="white"
                  label="Collection"
                  value="collection"
                ></v-radio>
                <v-radio
                  color="white"
                  label="Accession No."
                  value="accession_number"
                ></v-radio>
                <v-radio
                  color="white"
                  label="Production Date"
                  value="production_date_new"
                ></v-radio>
              </v-radio-group> -->
            </v-flex>
            <v-flex xs6>
              <div
                class="
                  body-2
                  grey--text
                  text--darken-2 text-uppercase
                  font-weight-thin
                  mb-1
                "
              >
                Secondary Sorting
              </div>
              <p-radio
                value="production_date_new"
                color="white"
                v-model="subsort"
                >Production Date</p-radio
              ><br />
              <p-radio value="classification" color="white" v-model="subsort"
                >Classification</p-radio
              ><br />
              <p-radio value="accession_number" color="white" v-model="subsort"
                >Accession No.</p-radio
              ><br />
              <p-radio value="sort_name" color="white" v-model="subsort"
                >Artist</p-radio
              ><br />
              <!-- <v-radio-group v-model="subsort" :mandatory="false" class="mt-0">
                <v-radio
                  color="white"
                  label="Production Date"
                  value="production_date_new"
                ></v-radio>
                <v-radio
                  color="white"
                  label="Classification"
                  value="classification"
                ></v-radio>
                <v-radio
                  color="white"
                  label="Accession No."
                  value="accession_number"
                ></v-radio>
              </v-radio-group> -->
            </v-flex>
          </v-layout>
          <v-layout row wrap mt-3>
            <v-flex xs12>
              <p-check color="white" v-model="group_by_series">Group by artwork series</p-check>
              <div class="caption grey--text text--darken-1 mt-1">Artworks in multiple series are included in each series group.</div>
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- OUTPUT FIELDS SELECT -->
        <v-flex xs6 pl-3 mt-0 pr-2>
          <span
            class="
              body-2
              grey--text
              text--darken-2 text-uppercase
              font-weight-thin
            "
            >Output Fields
          </span>
          <v-layout row wrap mt-0>
            <v-flex xs12 mt-0 pt-0>
              <!-- <v-checkbox v-model="selected" v-for="i in items" :key="i.id" :label="i.title" :value="i.id" @change="saveToStore" class="my-0 py-0"></v-checkbox> -->
              
              <v-combobox
               v-bind="$attrs" v-on="$listeners" :items="items_calc" v-model="selected"
               placeholder="Select Output Fields here and reorder below"
               class="pb-0 mb-0 mt-0 pt-0"
               color="black"
               hide-selected
               multiple
               clearable
               dense
               item-value="item"
               item-text="title"
               @change="saveToStore"
               @blur="search = ''"
               :search-input.sync="search"
               >
                <template v-slot:selection>
                  <div v-if="selected.length > 0" @click.stop="selected = []">
                    <!-- {{ selected.length }} item(s) selected -->
                  </div>

                  <!-- <v-chip v-if="selected.length > 0" close class="mr-2" @click.stop="selected = []">
                    {{ selected.length }} item(s) selected
                  </v-chip> -->
                </template>
              </v-combobox>
              
              <!-- <v-combobox
                v-model="selected"
                :items="items_calc"
              ></v-combobox> -->
            </v-flex>
            <v-flex xs12 mt-0 pt-0 pb-0>
              <div
                class="
                  body-2
                  grey--text
                  text--darken-2 text-uppercase
                  font-weight-thin
                  mb-0
                "
              >
                Output field options
              </div>
              <!-- <v-checkbox color="white" label="Show Advanced" v-model="show_advanced" ></v-checkbox> -->
              <!-- <p-check color="white" v-model="show_advanced" class="ml-1">
                <label color="white" slot="default">Show Advanced</label>
              </p-check>           -->
            </v-flex>

            <v-flex xs12 pl-0 mt-0 pt-0>
              <v-data-table
                v-model="selected"
                :items="selected"
                ref="sortableTable"
                hide-actions
                class="elevation-0"
                no-data-text="Select Output Fields above and reorder here."
                hide-headers
              >
                <template slot="items" slot-scope="props">
                  <tr class="sortableRow" :key="props.item['id']">
                    <td class="px-0" style="width: 0.1%">
                      <v-btn style="cursor: move" icon class="sortHandle">
                        <v-icon>drag_handle</v-icon>
                      </v-btn>
                    </td>
                    <!-- <td class="px-0" style="width: 0.1%"></td> -->
                    <td class="text-xs-left">{{ props.item.title }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>

            <!-- </v-flex> -->
          </v-layout>
        </v-flex>
        <v-flex xs12 mb-2>
          <v-divider class="xs12 mx-0 pb-0 mb-0 white mt-4"></v-divider>
        </v-flex>
        <!-- <v-flex xs1>
            <v-btn @click.prevent="resetFields()">SAVE </v-btn>
        </v-flex>-->
        <!-- </v-flex> -->
        <!-- </v-flex> -->
        <v-layout xs12 mx-0 px-0 mb-2 d-flex>
          <v-flex xs2>
            <v-btn small icon @click.prevent="pdf(false)" class="mr-0">
              <v-icon small>refresh</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs2>
            <v-btn
              small
              class="mx-0"
              @click.native="
                loading = true
                pdf_call(true)
              "
              :loading="loading"
              :disabled="loading"
            >
              <v-icon small class="mr-2">mdi-file-pdf</v-icon>
              LIST
            </v-btn>
          </v-flex>
          <!-- <v-flex xs2>
            <test-list small></test-list>
          </v-flex> -->
          <v-flex xs2>
            <labels small></labels>
          </v-flex>
          <v-flex xs2 small>
            <labels-small small></labels-small>
          </v-flex>
          <v-flex xs2 small>
            <labels-small-text small></labels-small-text>
          </v-flex>
          <v-flex xs2 small>
            <solo
              small
              :title="title"
              :subtitle="subtitle"
              :sort="sort"
              :subsort="subsort"
              :columns="selected"
            ></solo>
          </v-flex>
          <v-flex xs2 small>
            <solo-ext
              small
              :title="title"
              :subtitle="subtitle"
              :sort="sort"
              :subsort="subsort"
              :columns="selected"
            ></solo-ext>
          </v-flex>
          <v-flex xs2 small>
            <excel
              small
              :data="excelArtworks"
              name="List"
              :columns="selected"
              fileName="list"
            ></excel>
          </v-flex>
          <v-flex xs2 small>
            <text-review-excel
              :artworks="excelArtworks"
              @error="showExportError"
            ></text-review-excel>
          </v-flex>
          <v-flex xs2 small>
            <text-review-docx
              :artworks="excelArtworks"
              @error="showExportError"
            ></text-review-docx>
          </v-flex>
          <!-- <div class="mx-2 mt-2">Preview only shows one artwork to see the way it is going to look. Click DOWNLOAD LIST button to get full PDF.</div> -->
          <!-- <v-btn @click="clear">clear</v-btn> -->
        </v-layout>
      </v-layout>

      <v-card
        color
        class="mx-0 px-0 my-0 py-0"
        flat
        v-show="filter_view == 'data' && show_preview_pane"
      >
        <iframe
          id="pdfV"
          style="width: 100%; height: 640px; border: 0px"
        ></iframe>
      </v-card>

      <!-- <v-layout row pt-0 mt-0>
          <v-flex >
            <v-subheader class="white--text">
              Editing Artwork
      <v-spacer></v-spacer>-->
      <!-- <a @click="clear_selection" v-if="this.selected.length>0">Clear Selection</a> -->
      <!-- </v-subheader>
          </v-flex>
      </v-layout>-->
      <!-- </v-container> -->
      <!-- <v-list>
        <v-list-tile class="pl-0 ml-4" 
          v-for="tab in fields.tabs" :key="tab.key" 
          v-if="tab.work_types && tab.work_types.includes(artworkFormData.classification)"
          @click="setCurrentTab(tab['key'])"
          >
          <v-list-tile-content >
            <v-list-tile-title>{{ tab.title }} </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>-->

      <!-- <v-divider class="mx-3 pb-0 mb-0 white"></v-divider> -->

      <!-- <v-layout row pt-0 mt-0>
        <v-flex >
          <v-subheader class="white--text">
            Export PDF for:
            <v-spacer></v-spacer>
            <a @click="">Export</a>
          </v-subheader>
        </v-flex>
      </v-layout>-->

      <!-- <v-list>
        <v-list-tile class="pl-0 ml-4" @click="setCurrentTab(tab['key'])">
          <v-list-tile-content>
            <v-list-tile-title>Artwork Details </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>-->
    </v-navigation-drawer>

    <v-flex md12 xs12 mx-3>
      <v-form ref="form">
        <v-card color="red" flat>
          <v-card-text class="mb-0 px-0 mt-0 pt-0 white">
            <v-container fluid px-2>
              <v-layout row wrap>
                <v-flex xs12>
                  <filter-box
                    :use_current_selection="use_current_selection"
                    :artworks="unfiltered_artworks_for_list"
                  ></filter-box>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-form>
    </v-flex>
  </div>
</template>

<script>
import constants from '@/data/constants'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import FilterBox from './FilterBox'
import Labels from './Labels'
import LabelsSmall from './LabelsSmall'
import LabelsSmallText from './LabelsSmallText'
import Solo from './Solo'
import SoloExt from './SoloExt'
import { serverBus } from '../../main'
import Excel from '@/components/artworks/Excel'
import _ from 'lodash'
import ListsMixin from '@/mixins/ListsMixin'
import axios from '@/utils/apiClient'
import TextReviewExcel from './TextReviewExcel'
import TextReviewDocx from './TextReviewDocx'
import { dynamicSort } from '@/utils/artworkSort'

pdfMake.vfs = pdfFonts.pdfMake.vfs

export default {
  mixins: [ListsMixin],
  data: () => ({
    // show_advanced: false,
    show_preview_pane: false,
    constants: constants,
    filteredArtworks: [],
    options: false,
    filter_view: 'data', // musí byť data lebo inak nefunguje sorting of output fields
    filteredProperty: '0',
    query: '',
    anquery1: '',
    anquery2: '',
    anquery3: '',
    anquery4: '',
    query1: '',
    activeFilters: [],
    query_array: [],
    menu_acq_from: false,
    menu_acq_to: false,
    query_from: '',
    query_to: '',
    // filteredProperty: [],
    selection_for_adding: '',
    add_current_selection: '',
    // loader: null,
    loading: false,
    itemKeys: new WeakMap(),
    currentItemKey: 0,
    headers: [
      {
        sortable: false,
      },
      {
        text: 'title',
        align: 'left',
        sortable: false,
        value: 'name',
      },
    ],
    advanced: [
      { title: 'Technicians, Contacts …', id: 'technician' },
      { title: 'Space (max/min)', id: 'space_max_min' },
      { title: 'Technical Equipment', id: 'required_equipment' },
      { title: 'Existing Equipment', id: 'installation_requirements' },
      { title: 'Tools & Gear', id: 'tools_and_gear' },
      { title: 'Light', id: 'light' },
      { title: 'Climate & Conditions', id: 'climate_and_conditions' },
      { title: 'Power', id: 'power' },
      { title: 'Spare or replacement parts', id: 'spare_or_replacement_parts' },
      {
        title: 'Other / Special',
        id: 'display_notes_and_other_special_merged',
      },
      { title: 'Projection', id: 'projection' },
      { title: 'Sound and acoustic', id: 'sound_and_acoustic' },
      { title: 'On-and Off-Procedure', id: 'on_off_procedure' },
      { title: 'Maintenance', id: 'maintenance' },
      {
        title: 'Security and Safety Details',
        id: 'security_and_safety_details',
      },
      {
        title: 'Regular inspection/ Pay attention to',
        id: 'regular_inspection',
      },
      { title: 'Cleaning Artwork', id: 'cleaning_artwork' },
      { title: 'Contacts / Producers', id: 'contacts_producers' },
      { title: 'Hanging Devices', id: 'hanging_devices' },
      { title: 'Specification on space', id: 'specifications_on_space' },
      { title: 'Artist Nationality', id: 'artist_nationality' },
      { title: 'Artist Gender', id: 'artist_gender' },
      { title: 'Artist Decade', id: 'artist_decade' },
    ],
    items: [
      // { title: "Accession Number", id: "accession_number"},
      { title: 'Acquisition Date', id: 'acquisition_date' },
      { title: 'Acquisition Method', id: 'acquisition_method_text' },
      { title: 'Acquisition Price', id: 'purchase_price_text' },
      { title: 'Acquisition Source', id: 'acquisition_source_text' },
      // { title: "Artist", id:"name"},
      { title: 'Certificate', id: 'certificate_new' },
      { title: 'Classification', id: 'classification' },
      // { title: 'Conservator', id: 'conservator' },
      { title: 'Credit', id: 'credit' },
      { title: 'Deaccession Date', id: 'deaccession_date' },
      { title: 'Deaccessioned', id: 'deaccessioned' },
      { title: 'Dimensions', id: 'dim' },
      { title: 'Dimensions (Detail)', id: 'dim_detail' },
      { title: 'Edition State', id: 'edition_state' },
      { title: 'Exhibitions', id: 'exhibitions' },
      { title: 'Import Date', id: 'import_date' },
      { title: 'Import Taxes', id: 'import_taxes' },
      { title: 'Import Export History', id: 'import_export_history' },
      { title: 'Import Export Notes', id: 'import_export_notes' },
      { title: 'Insurrance Value (Legacy)', id: 'insurance_value_text' },
      { title: 'Insurrance Value Latest from History Log', id: 'insurance_value_latest' },
      { title: 'Last Media Check', id: 'last_media_check' },
      { title: 'Location', id: 'location_name' },
      { title: 'Location Notes', id: 'location_notes' },
      { title: 'Media/Material/Description', id: 'media_material_description' },
      { title: 'Ownership', id: 'ownership_info' },
      { title: 'ToDos', id: 'todos' },
      { title: 'Packings', id: 'packings' },
      { title: 'Paid in Country', id: 'paid_in_country' },
      // { title: "Production date", id:"production_date_new"},
      { title: 'Signature', id: 'signature_new' },
      { title: 'Type of Work', id: 'type_of_work_id' },
      // { title: "Title", id:"title"},
      { title: 'Visa status', id: 'visa_status_text' },
    ],
    selected: [],
    selected_settings: [],
    // output_list: [{name:'test',order:1,fixed:false},{name:'test2',order:2,fixed:false},{name:'test3',order:3,fixed:false}],
    searchFields: ['classification', 'ownership'],
    search_fields: [],
    searchtFieldsParams: [],
    search: '',
    outputFields: ['classification', 'ownership'],
    output_fields: [],
    outputFieldsParams: [],
    valid: true,
    list_settings: {
      use_current_selection: false,
      use_current_list_selection: false,
      financial_information: false,
      image: false,
      compact: false,
      table: true,
      view: 'table',
      sort: 'sort_name',
      add_empty_column: false,
    },
    use_current_selection: false,
    use_current_list_selection: false,
    financial_information: false,
    image: true,
    compact: false,
    table: true,
    view: 'table',
    sort: 'sort_name',
    subsort: 'accession_number',
    add_empty_column: false,
    xls: false,
    title: '',
    subtitle: '',
    imageSize2: '170',
    imageQuality: 'normal',
    pdf_artworks: [],
    created_by: false,
    created_at: false,
    page_no: true,
    artworkSeries: [],
    group_by_series: false,
    text_properties: [
      { name: 'Credit', value: 'credit' },
      { name: 'Edition', value: 'edition_state' },
      { name: 'Title', value: 'title' },
      { name: 'Artist Name', value: 'artist' },
      {
        name: 'Media material description',
        value: 'media_material_description',
      },
    ],
    bool_properties: [
      { name: 'Certificate', value: 'certificate_new' },
      { name: 'Deaccessioned', value: 'deaccessioned' },
      { name: 'Signature', value: 'signature_new' },
      { name: 'To-Dos', value: 'todos' },
    ],
    showNoOfArtworks: true,
    tag_categories: [
      { id: 1, name: 'TBA21 Exhibition', color: 'red', position: 2 },
      { id: 2, name: 'TBA21 Production', color: 'green', position: 3 },
      { id: 3, name: 'FTB Sorting', color: 'blue', position: 1 },
      { id: 4, name: 'TBA21 Projects', color: 'yellow', position: 4 },
      { id: 5, name: 'TBA21 Events', color: 'pink', position: 5 },
      { id: 6, name: 'Exhibitions', color: 'grey', position: 6 },
      { id: 7, name: 'Institutions', color: 'purple', position: 7 },
    ],
  }),
  created () {
    axios.get(`${this.$globals.apiserver}/artwork_series.json`)
      .then(response => { this.artworkSeries = response.data })
      .catch(() => { this.artworkSeries = [] })
  },
  // props: ['list', 'index', 'se', 'disable'],
  // created () {
  //   this.pdf(false)
  // },
  computed: {
    items_calc() {
      // return this.show_advanced ? this.items : this.items_advanced
      return this.items_advanced
    },
    items_advanced() {
      return this.items
        .concat(this.advanced)
        .sort((a, b) => (a.title > b.title ? 1 : b.title > a.title ? -1 : 0))
    },
    select_tags_assign() {
      // var stc = this.selected_tag_categories
      var tc = this.tag_categories
      var tags = Object.assign([], this.$store.state.tags)
      var out = []
      tags.forEach((tag) => {
        var a = tc.filter(function (tagc) {
          return tagc.id == tag.tag_category_id
        })
        if (a[0] > 0) {
          tag.color = a[0].color
        }
        out.push(tag)
      })
      out = out.sort(function (a, b) {
        var nameA = a.name ? a.name.toUpperCase() : '0' // ignore upper and lowercase
        var nameB = b.name ? b.name.toUpperCase() : '0' // ignore upper and lowercase
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }
        return 0
      })
      // return out.filter(function(tag) { return stc.some(st => tag.tag_category_id==st)})
      return out
    },
    locations() {
      var a = Object.assign([], this.$store.getters.enabled_locations)
      return a.sort(function (a, b) {
        return a.name.toUpperCase().localeCompare(b.name.toUpperCase())
      })
    },
    options_c: {
      get() {
        // if (this.$store.state.options) {
        //   this.selected = Object.assign([], this.$store.state.currentOutputFieldsSelection)
        //   new Sortable(
        //     this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
        //     {
        //       draggable: '.sortableRow',
        //       handle: '.sortHandle',
        //       onEnd: this.dragReorder
        //     }
        //   )
        // }
        return this.$store.state.options
      },
      set(value) {
        this.$store.dispatch('saveOptions', value)
      },
    },
    exhibitions() {
      var o = Object.assign([], this.$store.state.exhibitions)
      o = o.map((a) => {
        a.select_text = `${
          a.duration_start_year ? a.duration_start_year + ' - ' : ''
        } ${a.title.replace(/<\/?[^>]+(>|$)/g, ' ')}`
        return a
      })
      // o = o.sort(function(a, b){ if (a.select_text < b.select_text) { return -1; } if (a.select_text > b.select_text) { return 1; } return 0})
      o = o.sort(function (a, b) {
        a.id < b.id
      })
      return o
    },
    all_properties() {
      var all = this.text_properties.concat(this.bool_properties).concat([
        { name: 'Production Date', value: 'production_date_new' },
        { name: 'Location History', value: 'location_history' },
        { name: 'Deaccession Date', value: 'deaccession_date' },
        { name: 'Acquisition Date', value: 'acquisition_date' },
        // { name: 'Classification', value: 'classification' },
        // { name: 'Classification New', value: 'classification_new_id' },
        { name: 'Type of Work', value: 'type_of_work_id' },
        { name: 'Customs', value: 'visa_status' },
        { name: 'Location', value: 'artwork_location_id' },
        { name: 'Todos', value: 'todos' },
        { name: 'Packings', value: 'packings' },
        { name: 'Import Date', value: 'import_date' },
        { name: 'Acquisition Method', value: 'acquisition_method' },
        { name: 'Exhibitions', value: 'exhibitions' },
        { name: 'Artwork Series', value: 'artwork_series' },
        { name: 'Ownership', value: 'ownership' },
        { name: 'Ownership Status', value: 'acquired' },
        { name: 'Tags', value: 'tags' },
        { name: 'Accession No.', value: 'accession_number' },
      ])
      all = all.concat([{ name: 'Select a Field to Filter by', value: '0' }])
      all.sort(function (a, b) {
        var nameA = a.name.toUpperCase()
        var nameB = b.name.toUpperCase()
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }
        return 0
      })
      return all
    },
    // dblists() {
    //   return yaml.load(this.$store.state.lists[0].artworks)
    // },

    // TOTO sa POUZIVA V EXCELI ? ?
    excelArtworks() {
      var tempArtworks = []
      // DEFAULT - LOADS ARTWORKS FROM FILTER TABLE
      if (this.$store.state.filterResults) {
        // var objs = this.ids2o(this.$store.state.filterResults)
        tempArtworks = Object.assign([], this.$store.state.filterResults)
        // console.log('filtered')
        // console.log(tempArtworks)
      } else {
        tempArtworks = Object.assign([], this.unfiltered_artworks_for_list)
      }
      // IF SELECTION IS CHOSEN, LOADS ARTWORKS FROM SELECTION
      if (this.selection_for_adding) {
        var selections = Object.assign(
          [],
          this.$store.state.artworks_selections
        )
        var sel = selections.find((s) => s.title === this.selection_for_adding)
        var s = this.o2ids(sel.artworks, 'id')
        // console.log('from selection')
        // console.log(s)
        // console.log(tempArtworks)
        tempArtworks = tempArtworks.concat(s)
      }
      // ADDS ARTWORKS SELECTED IN COLLECTION TO LIST TOO
      if (this.add_current_selection) {
        // var objs = this.ids2o(this.$store.state.filterResults)
        var objs = Object.assign([], this.$store.state.currentSelection)
        var s = this.o2ids(objs, 'id')
        // console.log('currently selected')
        // console.log(s)
        tempArtworks = tempArtworks.concat(s)
        // console.log(tempArtworks)
      }
      // ADDS ONLY ARTWORKS CHECKED IN FILTERED RESULTS
      if (this.use_current_list_selection) {
        // var objs = this.ids2o(this.$store.state.filterResults)
        var objs = Object.assign([], this.$store.state.currentListSelection)
        var s = this.o2ids(objs, 'id')
        // console.log('currently selected in list')
        // console.log(s)
        tempArtworks = objs
        // console.log(tempArtworks)
      }

      tempArtworks = this.ids2o(tempArtworks)

      if (this.sort == 'collection') {
        var collectionsIds = [1, 12, 15, 6, 7, 17, 10]
        tempArtworks = this.customDoubleSort(
          tempArtworks,
          collectionsIds,
          'ownership',
          this.subsort
        )
      } else {
        tempArtworks = tempArtworks.sort(dynamicSort(this.sort, this.subsort))
      }

      return this.group_by_series ? this.groupArtworksBySeries(tempArtworks) : tempArtworks
    },
    // use_current_selection_computed() {
    //   if (this.currentSelection.length == 0 || this.currentSelection.length == null) {
    //     return false
    //   } else {
    //     return true
    //   }
    // },
    artworks_selections() {
      return Object.assign([], this.$store.state.artworks_selections).reverse()
    },
    // selected() {
    //   return this.$store.state.currentSelection
    // },
    currentSelection() {
      return this.$store.state.currentSelection
    },
    currentListSelection() {
      return this.$store.state.currentListSelection
    },
    unfiltered_artworks_for_list() {
      if (this.use_current_selection == true) {
        // this.$store.dispatch('saveArtworksForPdf',this.$store.state.currentSelection)
        // console.log('use_current_selection TRUE')
        // console.log(this.$store.state.currentSelection)
        // console.log(this.ids2o(this.$store.state.currentSelection))
        return this.ids2o(this.$store.state.currentSelection)
      } else {
        // console.log('use_current_selection FALSE')
        // console.log(this.$store.state.artworks.length)
        var filtered = this.$store.state.artworks
        // .filter(function(a) {
        //   return (a.ownership != 6 && a.ownership != 7 && a.ownership != 8 && a.ownership != 9 && a.ownership != 10)
        // })
        // this.$store.dispatch('saveArtworksForPdf',filtered)
        return filtered
      }
    },
  },
  created() {
    if (this.$route.params.loadCurrent) {
      this.use_current_selection = true
    }
    serverBus.$on('setUseCurrentSelectionCheckboxToFalse', (value) => {
      this.use_current_selection = value
    })
    serverBus.$on('updateFiltered', (value) => {
      this.filteredArtworks = value
    })
    this.$store.dispatch('loadArtworks')
  },
  mounted() {
    this.selected = Object.assign(
      [],
      this.$store.state.currentOutputFieldsSelection
    )
    // console.log(this.selected)
    /* eslint-disable no-new */
    new Sortable(
      this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
      {
        draggable: '.sortableRow',
        handle: '.sortHandle',
        onEnd: this.dragReorder,
      }
    )
  },
  methods: {
    showExportError(message) {
      serverBus.$emit('showSnackbar', message, 'red')
    },
    groupArtworksBySeries (artworks) {
      const groups = this.artworkSeries.reduce((memo, series) => {
        memo[series.id] = series.title_en
        return memo
      }, {})
      const grouped = []
      artworks.forEach(artwork => {
        const ids = Array.isArray(artwork.artwork_series_ids) ? artwork.artwork_series_ids : []
        if (ids.length) {
          ids.forEach(id => grouped.push(Object.assign({}, artwork, { _series_group: groups[id] || 'Artwork series' })))
        } else {
          grouped.push(Object.assign({}, artwork, { _series_group: 'Other artworks' }))
        }
      })
      return grouped.sort((a, b) => {
        const groupOrder = a._series_group === 'Other artworks' ? 1 : (b._series_group === 'Other artworks' ? -1 : a._series_group.localeCompare(b._series_group))
        return groupOrder || String(a.title || '').localeCompare(String(b.title || ''))
      })
    },
    addToSelection(s) {
      var ss = this.o2ids(s, 'id')
      this.$store.dispatch('addToCurrentSelection', ss)
    },
    closeOptions() {
      this.options = !this.options
      this.$store.dispatch('saveOptions', !this.$store.state.options)
    },
    // updateFilters () {
    //   this.activeFilters
    // },
    updateFilters: function () {
      serverBus.$emit('updateFilters', this.activeFilters)
    },
    keys2sentence(ks, fn) {
      var out = []
      for (var k in ks) {
        if (fn == 'acquisition_method') {
          for (var s in this.constants.ACQUISITION_METHODS) {
            if (ks[k] == this.constants.ACQUISITION_METHODS[s].id) {
              out.push(this.constants.ACQUISITION_METHODS[s].name)
            }
          }
          // return out.join(', ')
        } else if (fn == 'visa_status') {
          for (var s in this.constants.VISA_STATUSES) {
            if (ks[k] == this.constants.VISA_STATUSES[s].id) {
              out.push(this.constants.VISA_STATUSES[s].name)
            }
          }
          // return out.join(', ')
        } else if (fn == 'artwork_location_id') {
          for (var s in this.$store.state.locations) {
            if (ks[k] == this.$store.state.locations[s].id) {
              out.push(this.$store.state.locations[s].name)
            }
          }
        } else if (fn == 'tags') {
          for (var s in this.select_tags_assign) {
            if (ks[k] == this.select_tags_assign[s].id) {
              out.push(this.select_tags_assign[s].name)
            }
          }
          // return out.join(', ')
        } else if (fn == 'accession_number') {
          out.push(ks[k])
          // return out.join(', ')
        }
      }
      return out
    },
    addFilter() {
      // console.log('filter added lists')
      this.activeFilters.push({
        name: this.filteredProperty,
        value: this.query,
        value_from: this.query_from,
        value_to: this.query_to,
        value_array: this.query_array,
        anquery1: this.anquery1,
        anquery2: this.anquery2,
        anquery3: this.anquery3,
        anquery4: this.anquery4,
      })
      this.query = ''
      this.query_from = ''
      this.query_to = ''
      this.query_array = []
      this.filteredProperty = '0'
      this.updateFilters()
    },
    inverse(idx) {
      this.activeFilters.push({
        name: this.activeFilters[idx].name,
        value: this.activeFilters[idx].value,
        value_from: this.activeFilters[idx].value_from,
        value_to: this.activeFilters[idx].value_to,
        value_array: this.activeFilters[idx].value_array,
        inverse: this.activeFilters[idx].inverse ? false : true,
      })
      this.activeFilters.splice(idx, 1)
      // this.query = ''
    },
    removeFilter(idx) {
      this.activeFilters.splice(idx, 1)
    },
    o2ids(array, prop) {
      return array.map((a) => a[prop])
    },
    ids2o(array) {
      var objs = Object.assign([], this.$store.state.artworks)
      var out = objs.filter((a) => {
        return array.includes(a.id)
      })
      return out
    },
    saveCurrentSelectionToUser() {
      this.$store.dispatch('saveOutputFieldsToUser', {
        artworks: this.$store.state.currentSelection,
        title: this.selection_title,
        created_at: new Date().toISOString().substring(0, 19).replace('T', ' '),
      })
      this.save_selection_form_display = false
      this.selection_title = ''
    },
    loadSelection(e) {
      this.$store.dispatch('saveCurrentSelection', e)
    },
    saveToStore() {
      // this.selected  = []
      this.$store.dispatch(
        'saveCurrentOutputFieldsSelection',
        Object.assign([], this.selected)
      )
    },
    resetFields() {
      this.selected = []
      this.$store.dispatch('saveCurrentOutputFieldsSelection', [])
    },
    // format_date (date) {
    //   var moment = require('moment')
    //   var ndate = new Date(date)
    //   return moment(ndate).format('YYYY-MM-DD')
    // },
    dragReorder({ oldIndex, newIndex }) {
      // nacitam si do premennej item ktory treba presunut
      const movedItem = this.selected.splice(oldIndex, 1)[0]
      // vsuniem item na novy index
      this.selected.splice(newIndex, 0, movedItem)
      this.$store.dispatch(
        'saveCurrentOutputFieldsSelection',
        Object.assign([], this.selected)
      )
    },
    itemKey(item) {
      if (!this.itemKeys.has(item))
        this.itemKeys.set(item, ++this.currentItemKey)
      return this.itemKeys.get(item)
    },
    toggle(index, field) {
      const i = this.selected.indexOf(index)
      if (i > -1) {
        this.selected.splice(i, 1)
        this.output_fields.splice(i, 1)
      } else {
        this.selected.push(index)
        this.output_fields.push(field.id)
      }
      // this.$store.dispatch("saveSelectedColumnsForPdf",this.selected)
    },
    pdf_call(full) {
      this.loading = true
      setTimeout(
        function () {
          setTimeout(
            function () {
              this.pdf(full)
              this.loading = false
            }.bind(this),
            0
          )
        }.bind(this),
        500
      )
    },
    pdf(full) {
      // if (full == true) {
      //   this.loading = true
      // }
      console.log("this.selected")
      if (!full) {
        this.show_preview_pane = true
      }
      if (this.view == 'compact') {
        var heights = 50
        var margins = [0, 10, 0, 10]
      } else if (this.view == 'table') {
        var heights = 20
        var margins = [0, 10, 0, 10]
      } else {
        var heights = 150
        var margins = [0, 10, 0, 10]
      }
      var image = this.image
      var created = new Date().toISOString().slice(0, 10)
      var username = this.c_user.abb
      var list_name = this.title ? this.title.toUpperCase() : 'LIST'
      var image_size = [this.imageSize2, this.imageSize2]
      var output_fields = this.selected
      var imageSize3 = parseInt(this.imageSize2)
      var rectPosX = 220 - imageSize3
      var use_current_selection = this.use_current_selection
      var noOfArtworks = 0
      var logoImage = this.getLogo()
      logoImage = logoImage.split('\n')
      console.log("this.selected", output_fields)

      // if (this.item && this.item.artworks.length > 0) {
      //   this.pdf_artworks = this.item.artworks
      // } else {
      // if (use_current_selection == true) {
      //   // this.pdf_artworks = Object.assign([], this.$store.state.currentSelection)
      //   if (this.$store.state.currentSelection.length > 0) {
      //     this.pdf_artworks = Object.assign([], this.$store.state.currentSelection)
      //   } else {
      //     this.pdf_artworks = Object.assign([], this.$store.state.artworks)
      //   }
      // } else {
      var tempArtworks = []
      // DEFAULT - LOADS ARTWORKS FROM FILTER TABLE
      if (this.$store.state.filterResults) {
        // var objs = this.ids2o(this.$store.state.filterResults)
        tempArtworks = Object.assign([], this.$store.state.filterResults)
      } else {
        tempArtworks = Object.assign([], this.unfiltered_artworks_for_list)
      }
      // IF SELECTION IS CHOSEN, LOADS ARTWORKS FROM SELECTION
      if (this.selection_for_adding) {
        var selections = Object.assign(
          [],
          this.$store.state.artworks_selections
        )
        var sel = selections.find((s) => s.title === this.selection_for_adding)
        var s = this.o2ids(sel.artworks, 'id')
        tempArtworks = tempArtworks.concat(s)
      }
      // ADDS ARTWORKS SELECTED IN COLLECTION TO LIST TOO
      if (this.add_current_selection) {
        // var objs = this.ids2o(this.$store.state.filterResults)
        var objs = Object.assign([], this.$store.state.currentSelection)
        var s = this.o2ids(objs, 'id')
        tempArtworks = tempArtworks.concat(s)
      }
      // ADDS ONLY ARTWORKS CHECKED IN FILTERED RESULTS
      if (this.use_current_list_selection) {
        // var objs = this.ids2o(this.$store.state.filterResults)
        var objs = Object.assign([], this.$store.state.currentListSelection)
        var s = this.o2ids(objs, 'id')
        tempArtworks = objs
      }
      this.pdf_artworks = this.ids2o(tempArtworks)
      // }
      // }
      // console.log(this.pdf_artworks)
      if (this.sort == 'collection') {
        var collectionsIds = [1, 12, 15, 6, 7, 17, 10]
        this.pdf_artworks = this.customDoubleSort(
          this.pdf_artworks,
          collectionsIds,
          'ownership',
          this.subsort
        )
      } else {
        this.pdf_artworks = this.pdf_artworks.sort(
          dynamicSort(this.sort, this.subsort)
        )
      }
      if (this.group_by_series) {
        this.pdf_artworks = this.groupArtworksBySeries(this.pdf_artworks)
      }
      // console.log(this.pdf_artworks)

      if (full == false) {
        this.pdf_artworks = this.pdf_artworks.splice(0, 1)
      }

      let transformedData = this.formatListData(
        this.pdf_artworks,
        output_fields
      )
      transformedData.forEach((row, index) => {
        row._series_group = this.pdf_artworks[index] && this.pdf_artworks[index]._series_group
      })
      console.log("transformedData", transformedData)
      // var asMoney = function asMoney (rawMoney) {
      //   return rawMoney
      //     .round(2, 1)
      //     .toFixed(2)
      //     .toString()
      //     .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      // }
      const makeCell = (content, rowIndex = -1, options = {}) => {
        return Object.assign({ text: content }, options)
      }
      // -- Format the table cells for presentation.
      const thl = (content, rowIndex = -1, options = {}) => {
        return makeCell(
          content,
          rowIndex,
          Object.assign(
            { bold: false, alignment: 'left', fontSize: 9 },
            options
          )
        )
      }
      const thr = (content, rowIndex = -1, options = {}) => {
        return makeCell(
          content,
          rowIndex,
          Object.assign(
            { bold: false, alignment: 'right', fontSize: 9 },
            options
          )
        )
      }
      const tdl = (content, rowIndex = -1, options = {}) => {
        return makeCell(
          content,
          rowIndex,
          Object.assign(
            { bold: false, alignment: 'left', fontSize: 9 },
            options
          )
        )
      }
      const tdr = (content, rowIndex = -1, options = {}) => {
        return makeCell(
          content,
          rowIndex,
          Object.assign(
            { bold: false, alignment: 'right', fontSize: 9 },
            options
          )
        )
      }
      const creationDate = () => new Date()

      function getImagefromAPI(top_photo, id, image_size) {
        var request = new XMLHttpRequest()
        var requestER = new XMLHttpRequest()
        // request.open('GET', 'http://tb-cms.org/artworks/send_datauri/'+id, false);
        // if (image_size == [170,170]) {
        // console.log(accession_number)
        var src = ''
        console.log(image_size)
        if (id) {
          // if (top_photo && id > 0) {
          // if (image_size == ['170', '170']) {
          src = 'https://api.tb-cms.org/vueimages/' + id + '_big.txt'
          // } else {
          // src = 'http://api.tb-cms.org/vueimages/' + id + '.txt'
          // }
          //     //'http://tb-cms.org/data/artwork/' + id + '/' + top_photo_id + '_th_big.jpg'
          // } else if ([12,15,16].includes(ownership)) {
          //   src = 'http://tb-cms.org/vueimages/' + accession_number + '_big.txt'
          // }
          request.open(
            'GET',
            src,
            //"http://tb-cms.org/vueimages/" + id + "_big.txt",
            false
          )
          // console.log(src)
          // } else {
          // request.open('GET', 'http://tb-cms.org/vueimages/'+id+'.txt', false);
          // }
          // request.open('GET', 'http://tb-cms.org:8080/static/images/'+id, false);
          request.send(null)
          // request.onreadystatechange = function() {
          if (request.readyState === 4) {
            // console.log('readyState = 4')
            // var response = JSON.parse(request.responseText);
            if (request.status === 200 && request.statusText === 'OK') {
              // console.log('status OK')
              var type = request.getResponseHeader('Content-Type')
              if (type.indexOf('text') !== 1) {
                // console.log('text OK')
                return request.responseText
              }
            } else {
              // console.log('status not OK')
              requestER.open(
                'GET',
                'https://api.tb-cms.org/vueimages/ir.txt',
                false
              )
              requestER.send(null)
              if (requestER.readyState === 4) {
                // console.log('status not OK - 4')
                if (requestER.status === 200 && requestER.statusText === 'OK') {
                  // console.log('status not OK - 4 - OK')
                  var type = requestER.getResponseHeader('Content-Type')
                  if (type.indexOf('text') !== 1) {
                    return requestER.responseText
                  }
                } else {
                  return ''
                }
              }
            }
          }
        } else {
          // console.log('ir')
          requestER.open(
            'GET',
            'https://api.tb-cms.org/vueimages/ir.txt',
            false
          )
          requestER.send(null)
          if (requestER.readyState === 4) {
            // console.log('status not OK - 4')
            if (requestER.status === 200 && requestER.statusText === 'OK') {
              // console.log('status not OK - 4 - OK')
              var type = requestER.getResponseHeader('Content-Type')
              if (type.indexOf('text') !== 1) {
                return requestER.responseText
              }
            } else {
              return ''
            }
          }
        }
        // }
        // request.onreadystatechange = function () {
        //  if (request.readyState === 4 && request.status === 200) {
        // var type = request.getResponseHeader('Content-Type');
        // if (type.indexOf("text") !== 1) {
        // return request.responseText;
        // }
        // }
        // }
      }

      // function getLogo () {
      //   var request = new XMLHttpRequest()
      //   request.open('GET', 'http://tb-cms.org/vueimages/logo.txt', false)
      //   request.send(null)
      //   return request.responseText
      // }

      const createDocumentDefinition = (
        creationDate,
        subHeading,
        ...contentParts
      ) => {
        const baseDocDefinition = {
          defaultFileName: 'list.pdf',
          pageSize: 'A4',
          footer: (currentPage, pageCount) => {
            return {
              ...(this.page_no == true && {
                text:
                  'Page ' +
                  currentPage.toString() +
                  ' of ' +
                  pageCount.toString(),
                alignment: 'center',
                fontSize: 7,
              }),
              // text: `Page ${currentPage.toString()} of ${pageCount.toString()}`, alignment: 'center', fontSize: 7
            }
          },
          info: {
            title: list_name,
            author: username,
            subject: list_name,
            keywords: 'artwork names, artist names',
            creationDate: created,
          },
          styles: {
            title: { fontSize: 20, all_caps: true },
            titleSub: { fontSize: 9 },
            titleDate: { fontSize: 9, alignment: 'right', bold: false },
            createdAt: { fontSize: 9, alignment: 'right' },
            createdBy: { fontSize: 9, alignment: 'right' },
            bold: { fontSize: 9, bold: false },
            normal: { fontSize: 9, bold: false },
            artwork_title: { fontSize: 9, bold: false },
            artwork_title_top: {
              fontSize: 9,
              bold: false,
              margin: [0, 13, 0, 0],
            },
            artist_name: { fontSize: 9, italic: true, margin: [0, 25, 0, 0] },
            image: { alignment: 'right', margin: [0, 0, 0, 30] },
            logo: { alignment: 'left', margin: [0, 0, 0, 40] },
          },
          content: [
            { image: logoImage, fit: [180, 80], style: 'logo', width: '*' },
            {
              columns: [
                { text: list_name, style: 'title', width: '*' },
                {
                  text:
                    (this.created_by == true
                      ? 'Created by : ' + username
                      : '') +
                    (this.created_at == true ? '\n' + created : '') +
                    (this.showNoOfArtworks == true
                      ? '\nNo. of Artworks: ' + this.pdf_artworks.length
                      : ''),
                  style: 'createdBy',
                },
                // { text: ((this.showNoOfArtworks == true) ? 'No. of Artworks: '  + this.pdf_artworks.length : ''), style: 'createdBy'}
                // {...(this.created_by == true) && { text: '\nCreated by ' + username, style: 'createdBy'}},
                // {...(this.created_at == true) && { text: created, style: 'createdAt'}}
              ],
            },
            { text: `${this.subtitle}\n\n`, style: 'titleSub' },
          ],
        }
        const docDefinition = JSON.parse(JSON.stringify(baseDocDefinition))
        docDefinition.footer = baseDocDefinition.footer
        docDefinition.content.push(...contentParts)
        // console.log(contentParts)
        // console.log(docDefinition)
        return docDefinition
      }

      var rowData = function rowData(a) {
        var stack = {
          stack: [],
          stack2: [],
        }

        var columns = output_fields
        // this.$store.state.selected_columns_for_pdf
        // ['title','accession_number'];

        stack.stack.push({
          text: a['accession_number'],
          style: 'artwork_title_top',
        })
        stack.stack.push({ text: a['full_name'], style: 'artwork_title' })
        stack.stack.push({ text: a['title'], style: 'artwork_title' })
        stack.stack.push({ text: a['subtitle'], style: 'artwork_title' })

        columns.forEach((column, index) => {
          // unformattedData = pdf_artworks.find(b => b.id === a['id'])
          // if (unformattedData[column.id]) {
          var columnData = a[column.id]
          var cp = []
          // if (columnData == undefined) {
          //   stack.stack.push({text: 'no "' + column.title + '" data entered', style: 'normal'});
          // } else {
          // console.log('columnData')
          // console.log(columnData)
          if (columnData != null && columnData.trim().length != 0) {
            console.log(columnData)
            console.log(column)
            stack.stack.push({ text: columnData, style: 'normal' })
          } else {
            // console.log(column.id)
            // console.log(columnData)
          }
          // }
        })
        return stack
      }

      createPdfDoc()

      function createPdfDoc() {
        const fontSize = 6

        var tableBody = function tableBody(dataRows) {
          var body = []
          var currentSeries = null
          dataRows.forEach(function (row, index) {
            if (row._series_group && row._series_group !== currentSeries) {
              currentSeries = row._series_group
              body.push([{ text: currentSeries, bold: true, fontSize: 13, margin: [0, 12, 0, 5], colSpan: 2 }, {}])
            }
            var tableRow = []
            // obldznik namiesto obrazku zatial
            // var rect = {
            //   canvas: [
            //     {
            //       type: 'rect',
            //       x: rectPosX,
            //       y: 20,
            //       w: imageSize3,
            //       h: imageSize3,
            //       // r: 5,
            //       // dash: {length: 5},
            //       // lineWidth: 10,
            //       lineColor: 'grey',
            //     }]
            // }

            if (image == true) {
              var imagefromAPI = getImagefromAPI(
                row.top_photo,
                row.top_photo_id,
                image_size
              )
              imagefromAPI = imagefromAPI.split('\n')
              if (imagefromAPI.length == 2) {
                imagefromAPI = imagefromAPI.filter(function (el) {
                  return el != ''
                })
              }
              // imagefromAPI = imagefromAPI[0].replace("image/jpg","image/jpeg");
            }
            // console.log (row.accession_number);
            // console.log (row);

            tableRow.push(rowData(row))

            if (image == true) {
              tableRow.push({
                image: imagefromAPI,
                fit: image_size,
                style: 'image',
              })
            }

            // tableRow.push(rect)

            body.push(tableRow)
          })
          return body
        }
        if (image == true) {
          var tableColumnWidths = [290, 222]
        } else {
          var tableColumnWidths = [480, 20]
        }
        var tableData = {
          layout: 'noBorders',
          table: {
            heights: heights,
            dontBreakRows: true,
            margins: margins,
            widths: tableColumnWidths,
            body: tableBody(transformedData),
          },
        }
        var docDefinition = createDocumentDefinition(
          creationDate(),
          'Summary',
          tableData
        )
        // pdfMake.createPdf(docDefinition).download('underlyingLoanSummary-' + creationDate() + '.pdf');
        // pdfMake.createPdf(docDefinition).open({},'pdfV')
        // document.getElementById('pdfV').src = data;

        if (full == false) {
          const pdfDocGenerator = pdfMake.createPdf(docDefinition)

          // function download() {
          //   pdfDocGenerator.download('A4-list.pdf');
          // }
          pdfDocGenerator.getDataUrl((dataUrl) => {
            const targetElement = document.querySelector('#pdfV')
            // const iframe = document.createElement('iframe')
            targetElement.src = dataUrl
            // targetElement.appendChild(iframe)
            // this.loading = false
          })
        } else {
          if (list_name) {
            var t = list_name + '.pdf'
          } else {
            var t = 'list.pdf'
          }
          // this.loading = false
          pdfMake.createPdf(docDefinition).download(t)
        }
        // this.loading = false
        // const docDefinition = createDocumentDefinition(creationDate(), 'LIST', ' ', tableData)
        // pdfMake.createPdf(docDefinition).download(`LISTa-${creationDate()}.pdf`)
      }
      // this.loading = false
    },
    getDataUri(url, callback) {
      var image = new Image()
      image.onload = function () {
        var canvas = document.createElement('canvas')
        canvas.width = this.naturalWidth // or 'width' if you want a special/scaled size
        canvas.height = this.naturalHeight // or 'height' if you want a special/scaled size
        canvas.getContext('2d').drawImage(this, 0, 0)
        callback(
          canvas
            .toDataURL('image/jpg')
            .replace(/^data:image\/(png|jpg);base64,/, '')
        )
        callback(canvas.toDataURL('image/jpg'))
      }
      image.src = url
    },
  },
  components: {
    FilterBox,
    Labels,
    LabelsSmall,
    LabelsSmallText,
    Solo,
    SoloExt,
    // TestList,
    Excel,
    TextReviewExcel,
    TextReviewDocx,
  },
}
</script>

<style scoped>
.v-list__tile {
  height: auto !important;
}
/* .v-input--selection-controls.v-input .v-label {
    color: rgba(255, 255, 255, 0.8) !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/lists/Lists.vue